import { cryptoInstance } from '@/public/fetch/index';
import { mallApi2 } from '@/public/utils/basePath';
const baseURL = mallApi2;
/**
 * @params
 * userId
 * @query
 * labelId 亚专业id
 * pageSize 默认 10
 * pageNo
 */
export const getMallList = ({ params, query }) => {
    // 获取训练营列表
    return cryptoInstance.get(`/v5/mall/list/${params.userId}`, {
        baseURL: mallApi2,
        params: query
    });
};
// 获取抽奖列表
export const getActivityList = ({ params, query }) => {
    return cryptoInstance.get(`/mall_lottery/activity_list/${params.userId}/${params.depId}`, {
        baseURL: mallApi2,
        params: query
    });
};
// 获取抽奖记录列表
export const getRecordList = ({ params, query }) => {
    return cryptoInstance.get(`/mall_lottery/record_list/${params.userId}/${params.type}`, {
        baseURL: mallApi2,
        params: query
    });
};
// 商城抽奖
export const mallRaffle = (activityId, userId) => {
    return cryptoInstance.post(`/mall_lottery/lottery/${activityId}/${userId}`, {}, { baseURL: mallApi2 });
};
// 商场抽奖活动详情活动
export const getRaffleDetail = (activityId, userId) => {
    return cryptoInstance.get(`/mall_lottery/activity_detail/${activityId}/${userId}`, { baseURL: mallApi2 });
};
// 中奖列表
export const getWinningList = (activityId, params) => {
    return cryptoInstance.get(`/mall_lottery/winning_list/${activityId}`, {
        baseURL: mallApi2,
        params
    });
};
// 创建订单
export const createGoodOrder = (data) => {
    return cryptoInstance.post(`/v3/order/create`, data, { baseURL });
};
